import { BrowserRouter } from "react-router-dom";
import UserRoutes from "./Routes/index";
import { ToastContainer } from './util/Toast';
import { SettingsProvider } from "./user/util/SettingsProvider";
function App() {
  return (
    <BrowserRouter>
      <ToastContainer />
      <SettingsProvider>
        <UserRoutes />
      </SettingsProvider>
    </BrowserRouter>
  );
}

export default App;